import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { aboutPic, cusPic } from "../constants/about";

const About = () => {
  const { t } = useTranslation("about");

  return (
    <section className="w-full bg-gray-50">
      {/* Hero Section */}
      <div className="max-w-screen-2xl mx-auto px-4 xl:px-10 2xl:px-20 py-10 text-center">
        <h1 className="text-xl uppercase xl:text-4xl font-extrabold dark:text-yellow-500 mb-3">
          {t("title")}
        </h1>
        <p className="text-lg md:text-xl max-w-4xl mx-auto">{t("intro")}</p>
      </div>
      {/* What We Serve */}
      <div className="w-full">
        <div className="max-w-screen-2xl mx-auto xl:px-6 2xl:px-6 sm:py-2 px-2 py-2 grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-6 items-center">
          {aboutPic.map((items, index) => (
            <div key={index} className="p-1">
              <img
                src={items.image}
                alt="About Mantic"
                className="rounded-xl shadow-xl w-full object-cover transform hover:scale-105 transition duration-300"
              />
            </div>
          ))}
        </div>

        <div className="max-w-screen-2xl mx-auto px-4 xl:px-10 2xl:px-20 py-3 text-center">
          <h1 className="text-xl xl:text-3xl uppercase font-bold dark:text-yellow-500 mb-3">
            {t("customer")}
          </h1>
        </div>

        <div className="max-w-screen-2xl mx-auto xl:px-6 2xl:px-6 sm:py-2 px-2 py-2 grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-6 items-center">
          {cusPic.map((items, index) => (
            <div key={index} className="p-1">
              <img
                src={items.image}
                alt="About Mantic"
                className="rounded-xl shadow-xl w-full object-cover transform hover:scale-105 transition duration-300"
              />
            </div>
          ))}
        </div>
      </div>
      {/* Visit Us */}
      <div className="w-full text-center py-4">
        <div className="max-w-screen-2xl mx-auto px-4 xl:px-10 2xl:px-20">
          <h2 className="text-xl xl:text-3xl uppercase font-bold dark:text-yellow-500 mb-3">
            {t("visit_us_title")}
          </h2>
          <p className="text-lg xl:text-xl max-w-4xl mx-auto">
            {t("visit_us_text")}
          </p>
          <Link
            target="_blank"
            to="https://maps.app.goo.gl/QfyLDggvuJ2pXbtZ6"
            className="mt-5 inline-block bg-yellow-500 hover:bg-yellow-700 text-white font-semibold py-2.5 px-6 rounded-full shadow-lg transition duration-300"
          >
            {t("get_directions")}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default About;
